import React, { useEffect } from "react";
import "./DosaChutneyGallery.scss"
import heroBackground from "../../assets/images/galleryBg.png"
import border from "../../assets/images/border.png"
const DosaChutneyGallery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const data = [
        { "src": "https://media.istockphoto.com/id/471668971/photo/crepes-with-strawberry-jam.jpg?s=612x612&w=0&k=20&c=0rrUk1d5-QPKOwRaES-m0NaCQtxq_5qZb9I9m_3-qj0=" },
        { "src": "https://media.istockphoto.com/id/172204271/photo/european-style-pancakes-on-a-plate.jpg?s=612x612&w=0&k=20&c=5utR8Mnjw42lTc41lrb1nrgXrQlCv3wp9w_lqJR1Ho4=" },
        { "src": "https://media.istockphoto.com/id/1308452271/photo/fried-tofu-with-sesame-seeds-and-green-onion.jpg?s=612x612&w=0&k=20&c=Uei9IfRhzNYYNTUAuyBRjgRwhTVN8cI7CMJ5T5TLlJU=" },
        { "src": "https://media.istockphoto.com/id/876446302/photo/chicken-rice-cabbage-cutlets.jpg?s=612x612&w=0&k=20&c=naSfhdK4WI9tR2IfNuz89rOpHQCDjqpSqi6zpvah87c=" },
        { "src": "https://media.istockphoto.com/id/182033089/photo/beef-samosa.jpg?s=612x612&w=0&k=20&c=xBOL3xxulqBIpNh6b8vZZPY9kad1NjQrj1X4LZtEeAI=" },
        { "src": "https://media.istockphoto.com/id/1555947107/photo/set-of-sushi-and-maki.jpg?s=612x612&w=0&k=20&c=Tdt7UyRfO-JERN_SXIdf-l8uhD_dVDyH-xzXYh2Q5-Y=" },
        { "src": "https://media.istockphoto.com/id/1932758217/photo/chopstick-with-sushi-roll-and-soy-sauce.jpg?s=612x612&w=0&k=20&c=bRS1LsmIWGBi27O97EeS1k3UPlfiYukBxAzwGxq5TjQ=" },
        { "src": "https://media.istockphoto.com/id/2060491170/photo/sushi-sashimi-japanese-seafood-fresh-japanese-fish.jpg?s=612x612&w=0&k=20&c=AaAG7xSVj2x-zY2wcO_7wXNTAzdHf3FmiW0dOTg-dxQ=" },
        { "src": "https://media.istockphoto.com/id/135849804/photo/sushi.jpg?s=612x612&w=0&k=20&c=GsScECjr2Saef-WibQe6goRwJ9wAcfWYuABCXZ3lyIg=" },
        { "src": "https://media.istockphoto.com/id/1176929581/photo/chopstick-holding-sushi-rolls-set-with-salmon-and-cream-cheese-and-cuccumber-on-black-slate.jpg?s=612x612&w=0&k=20&c=ctmjAzHzxnVSzvBruJt__oucuqn6g-V1Jadv-PRwLj8=" },
    ]
    return (
        <div className="DosaChutneyGallery">
            <div className="DosaChutneyGallery-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                <div className="DosaChutneyGallery-Hero-header">
                    Gallery of Flavours
                </div>
                <div className="DosaChutneyGallery-Hero-subheader">
                    Explore the Art of Taste
                </div>
            </div>
            <div className="DosaChutneyGallery-Container">
                <div className="DosaChutneyGallery-Container-header">
                    <div className="DosaChutneyGallery-Container-header-subtext">
                        The Taste of Food
                    </div>
                    <div className="DosaChutneyGallery-Container-header-text">
                        Food Gallery
                    </div>
                    <img alt="" src={border}
                        className="DosaChutneyGallery-Container-header-border" />
                </div>
                <div className="DosaChutneyGallery-Container-grid">
                    {data.map((gallery, key) => {
                        return (
                            <img alt="" key={key} src={gallery?.src}
                                className="DosaChutneyGallery-Container-grid-img" />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
export default DosaChutneyGallery
